// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import _ from 'lodash';
// local
import t from 'app/lib/i18n';
// Views
import SaveUpdateModal from './SaveUpdateModal';
import DropdownClient from 'app/ui/commons/DropdownClient';
import DropdownPatient from 'app/ui/commons/DropdownPatient';
// import DropdownFormula from '../commons/DropdownFormula';
import CustomDropdown from '../commons/CustomDropdown';
import ErrorLabel from 'app/ui/commons/ErrorLabel';
// libs
import { _val, sortString } from 'app/lib/helper';
import { isFormValid, removeReadOnly } from 'app/lib/formHelper';
// actions
import { ACTION } from 'app/redux/actions/modal';
import { create, update } from 'app/redux/actions/device';
// consts
import { TYPE as CLIENT_TYPE, STATUS as CLIENT_STATUS } from 'salvus-shared/consts/client';
import { TYPE as DEVICE_TYPE } from 'salvus-shared/consts/device';
import { STATUS as PATIENT_STATUS } from 'salvus-shared/consts/patient';

class DeviceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: this.initForm(),
            deviceTypes: this.initDeviceTypes(),
            errors: {},
        };
    }

    componentWillReceiveProps(nextProps) {
        const { isOpened: isOpenedP } = this.props.modalSaveUpdate;
        const { isOpened: isOpenedN, action: actionN, data: dataN } = nextProps.modalSaveUpdate;

        if (!isOpenedP && isOpenedN) {
            const values = actionN === ACTION.UPDATE ? dataN : {};
            this.setState({ form: this.initForm(values), errors: {} });
        }
    }

    initForm(values = {}) {
        console.log(values)
        return {
            id: _val(values.id, null),
            key: _val(values.key, ''),
            type: _val(values.type, null),
            clientId: _val(values.clientId, null),
            patientId: _val(values.patientId, null),
            formulaId: _val(values.formulaId, null),
        };
    }

    initDeviceTypes() {
        const types = Object.keys(DEVICE_TYPE).map(key => {
            const value = DEVICE_TYPE[key];
            return {
                text: t(`device_type_${value}`),
                value,
            };
        });
        types.sort((a, b) => sortString(a.text, b.text));
        return types;
    }

    validateForm(form, field) {
        const errors = {};

        const key = form.key;
        if (!field || field === 'key') {
            if (_.isEmpty(key)) {
                errors['key'] = 'O campo identificador é obrigatório.';
            } else {
                errors['key'] = undefined;
            }
        }

        return errors;
    }

    onChange = field => (e, target) => {
        let { value } = target || e.target;
        if (field === 'key') {
            value = _.toUpper(value);
        }
        let { form, errors } = this.state;
        _.set(form, field, value);
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });
        this.setState({ form, errors });
    };

    hasError = field => !_.isEmpty(this.state.errors[field]);

    onConfirmModal = () => {
        // check if there is any error in the form
        const errors = this.validateForm(this.state.form);
        if (!isFormValid(errors)) {
            this.setState({ errors });
            // return false to not close the popup
            return false;
        }
        // if there are not errors, submit to the backend
        const { form } = this.state;
        const { action } = this.props.modalSaveUpdate;
        if (action === ACTION.ADD) {
            this.props.dispatch(create(form));
        } else if (action === ACTION.UPDATE) {
            this.props.dispatch(update(form.id, form));
        }
        // return false to not close the popup
        return false;
    };

    render() {
        // props
        const { dispatch, modalSaveUpdate, auth } = this.props;
        const options = {
            dispatch,
            title: 'Dispositivos',
            onConfirmModal: this.onConfirmModal,
            action: modalSaveUpdate.action,
            isOpened: modalSaveUpdate.isOpened,
            loading: modalSaveUpdate.loading,
            error: modalSaveUpdate.error,
        };
        // state
        const { form, errors, deviceTypes } = this.state;
        return (
            <SaveUpdateModal id="deviceModal" options={options}>
                <Form>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Identificador Dispositivo" error={errors['key']} />}
                            placeholder="Identificador"
                            disabled={auth.account.client.type !== CLIENT_TYPE.SALVUS}
                            width={16}
                            value={form.key}
                            onChange={this.onChange('key')}
                            error={this.hasError('key')}
                            maxLength="255"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    <Form.Group>
                        {auth.account.client.type === CLIENT_TYPE.SALVUS && (
                            // <DropdownFormula
                            //     placeholder={'--'}
                            //     label={<ErrorLabel label="Formula" error={null} />}
                            //     width={16}
                            //     value={form.formulaId}
                            //     onChange={this.onChange('formulaId')}
                            // />
                            <CustomDropdown
                                label={<ErrorLabel label="Tipo" error={errors['type']} />}
                                placeholder="-"
                                width={16}
                                options={deviceTypes}
                                value={form.type}
                                onChange={this.onChange('type')}
                                error={this.hasError('type')}
                                selection
                            />
                        )}
                        {auth.account.client.type === CLIENT_TYPE.SALVUS ? (
                            <DropdownClient
                                width={16}
                                value={form.clientId}
                                onChange={this.onChange('clientId')}
                                filter={[CLIENT_STATUS.NEW, CLIENT_STATUS.ENABLED]}
                            />
                        ) : (
                            <DropdownPatient
                                label="Paciente"
                                placeholder="Selecione o paciente"
                                width={16}
                                value={form.patientId}
                                filter={[PATIENT_STATUS.NEW, PATIENT_STATUS.DEACTIVATED]}
                                filterFn={p => p.deviceId === null}
                                onChange={this.onChange('patientId')}
                                patient={modalSaveUpdate.data ? modalSaveUpdate.data.patient : null}
                            />
                        )}
                    </Form.Group>
                </Form>
            </SaveUpdateModal>
        );
    }
}

DeviceModal.propTypes = {
    modalSaveUpdate: PropTypes.object,
    auth: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
    modalSaveUpdate: state.modalSaveUpdate,
});
export default connect(mapStateToProps)(DeviceModal);
